import _ from 'lodash';
import { restoreSettingsDraft } from './settings_draft';

// Ordinary lighting settings share the existing global catalog draft lifecycle.
// This GUI-only map is stripped by lightCatalogPayload before transmission.
export function getLightCopyZoneSettings(controller, catalog, zone, activeZone, activeValues) {
  if (Number(zone) === Number(activeZone)) return _.cloneDeep(activeValues);
  return _.cloneDeep(
    restoreLightCopyZoneSettings(catalog, zone, controller.zones?.[zone]?.temp_settings?.lights) ??
      controller.zones?.[zone]?.settings?.lights
  );
}

export function withLightCopyZoneSettings(catalog, zone, lights, priorDraft) {
  return {
    ...catalog,
    _zone_lights: { ...catalog._zone_lights, [zone]: _.cloneDeep(lights) },
    ...(priorDraft !== undefined && {
      _zone_lights_prior_drafts: {
        ...catalog._zone_lights_prior_drafts,
        [zone]: _.cloneDeep(priorDraft)
      }
    })
  };
}

export function restoreLightCopyZoneSettings(catalog, zone, ordinaryDraft = {}) {
  const copied = catalog?._zone_lights?.[zone];
  if (!copied) return undefined;
  // An older, independently retained draft must not undo the confirmed copy.
  // Once the destination form has been edited, its later changes remain valid.
  const beforeCopy = catalog?._zone_lights_prior_drafts?.[zone];
  return beforeCopy !== undefined && _.isEqual(beforeCopy, ordinaryDraft)
    ? _.cloneDeep(copied)
    : restoreSettingsDraft(copied, ordinaryDraft);
}

export function prepareLightCopyZoneSettings(catalog, activeZone, activeValues, controller) {
  let next = catalog;
  for (const zone of Object.keys(catalog?._zone_lights ?? {})) {
    if (Number(zone) === Number(activeZone)) {
      next = withLightCopyZoneSettings(next, zone, activeValues);
    } else if (controller) {
      next = withLightCopyZoneSettings(
        next,
        zone,
        restoreLightCopyZoneSettings(catalog, zone, controller.zones?.[zone]?.temp_settings?.lights)
      );
    }
  }
  return next;
}

// Keep the current zone on the normal form save path. Remote copies use that
// same StateManager API; no Time, IO, scheduler or unrelated drafts are changed.
// A failed send keeps the global draft intact so the user can retry.
export function saveLightCopyZoneSettings(controller, catalog, stateManager, activeZone) {
  const copies = Object.entries(catalog?._zone_lights ?? {}).filter(
    ([zone]) => Number(zone) !== Number(activeZone)
  );
  if (copies.some(([zone, lights]) => !controller.zones?.[zone] || !_.isPlainObject(lights)))
    return false;
  for (const [zone, lights] of copies) {
    const effective = restoreLightCopyZoneSettings(
      catalog,
      zone,
      controller.zones[zone].temp_settings?.lights
    );
    if (
      !stateManager.saveSettings(controller, controller.zones[zone], effective ?? lights, 'lights')
    )
      return false;
  }
  return true;
}
